// src/pages/LandingPage.tsx — themed gate for unauthenticated visitors.
// Shown instead of the app shell: no sidebar, no navigation, nothing about
// the admin surface is revealed until a session exists.
import { useSearchParams } from 'react-router-dom';
import { Sigil } from '../components/Sigil';

export function LandingPage() {
  const [params] = useSearchParams();
  const expired = params.get('auth_error') === 'expired';

  return (
    <div className="min-h-screen flex flex-col bg-bg text-ink">
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md text-center">
          <div className="flex justify-center mb-6">
            <Sigil size={72} />
          </div>
          <div className="font-mono text-[10px] tracking-eyebrow uppercase text-ink-3 mb-2">
            EOTIR · Authentication Bridge
          </div>
          <h1 className="font-display font-bold text-[26px] tracking-[0.04em] uppercase text-ink mb-6">
            OIDC Bridge Admin
          </h1>

          {expired && (
            <div className="eo-toast eo-toast--warn mb-5 text-left">
              Your sign-in attempt expired. Please try again.
            </div>
          )}

          <a href="/api/auth/login" className="eo-btn inline-block px-10 py-2.5 text-[13px]">
            Sign in with EOTIR Nexus
          </a>

          <p className="font-mono text-[10.5px] tracking-label uppercase text-ink-4 mt-8 leading-relaxed">
            Restricted system — authorized EOTIR personnel only.
            <br />
            Access requires forum staff membership. All activity is logged.
          </p>
        </div>
      </main>
      <footer className="border-t border-line bg-bg-1 px-7 py-2.5 font-mono text-[10px] tracking-label uppercase text-ink-4 text-center">
        EOTIR · OIDC Bridge · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
